'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoPromiseManagementController = function () {
  function AutoPromiseManagementController(authService, enums, lookupService, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AutoPromiseManagementController);
    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
      return;
    }

    this.authService = authService;
    this.lookupService = lookupService;
    this.$state = $state;

    this.initializeEntityList();
  }

  (0, _createClass3.default)(AutoPromiseManagementController, [{
    key: 'initializeEntityList',
    value: function initializeEntityList() {
      var _this = this;

      var ctrl = this;

      var entityIds = ctrl.authService.getEntitiesForManagement(3);

      ctrl.lookupService.lookupEntityNamesByIds(entityIds).then(function (entityNameLookups) {
        var firstItem = {
          entityId: 0,
          name: '---- Select Location ----'
        };

        _this.selectedEntity = firstItem;
        ctrl.entities = [firstItem].concat((0, _toConsumableArray3.default)(entityNameLookups));
      });
    }
  }, {
    key: 'updateSelectedEntity',
    value: function updateSelectedEntity() {
      this.$state.go('autoPromiseManagement.container', { locationId: this.selectedEntity.entityId }, { reload: true });
    }
  }]);
  return AutoPromiseManagementController;
}();

exports.default = AutoPromiseManagementController;


// WEBPACK FOOTER //
// ./client/app/components/admin/autoPromiseManagement/autoPromiseManagement.controller.js